export const APPLE_STORE_APP_LINK = `${process.env.REACT_APP_URL}/mobile/app`
export const GOOGLE_STORE_APP_LINK = `intent://app.surglogs.com/mobile/app/#Intent;scheme=https;package=com.surglogs.app;S.browser_fallback_url=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dcom.surglogs.app;end;`
